import { useQuery } from "@tanstack/react-query";
import { Button, Card, Descriptions, Flex } from "antd";
import { useNavigate, useParams } from "react-router";
import { contactService } from "../../services/contact.service";
import { format } from "date-fns";

export default function ContactForm(){

  const { id } = useParams()

  const navigate = useNavigate()

  const { data: contact } = useQuery({
    queryKey: ['contactDetail', id],
    queryFn: () => contactService.getById(id),
    enabled: !!id
  })

  return (
    <>
      <Card
        title={ (id ? "Detail" : "Tambah") + " Data"}
        actions={[
          <Flex key={1} justify="end" style={{ paddingRight: 24 }} gap={16} >
            <Button onClick={() => navigate('/contact')} variant="outlined" color="primary" >
              Kembali
            </Button>
          </Flex>
        ]}
      >
        <Descriptions
          bordered  
          size="small"
          column={2}
          items={[
            {
              label: 'Nama',
              children: contact?.data.name
            },
            {
              label: 'Tanggal Aduan',
              children: contact?.data?.createdAt && format(new Date(contact?.data?.createdAt), 'EEEE, dd-MM-yyyy')
            },
            {
              label: 'Email',
              children: contact?.data?.email
            },
            {
              label: 'No Telepon',
              children: contact?.data?.phone
            },
            {
              label: 'ID Pelanggan',
              children: contact?.data?.customer_id
            },
            {
              label: 'Jenis Layanan',
              children: contact?.data?.type
            },
            {
              label: 'Alamat Lengkap',
              children: contact?.data?.address,
              span: 2
            },
            {
              label: 'Deskripsi',
              children: contact?.data?.description,
              span: 2
            },
          ]}
        />
      </Card>
    </>
  )
}